"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

const navLinks = [
    { label: "Home", href: "/homepage" },
    { label: "Products", href: "/products" },
    { label: "Operations", href: "/operations" },
    { label: "Commercial", href: "/commercial" },
    { label: "ESG", href: "/esg" },
    { label: "Partner", href: "/partner" },
    { label: "About", href: "/about" },
    { label: "Contact", href: "/contact" },
];

export default function Header() {
    const pathname = usePathname();
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    return (
        <>
            {/* ── Main Nav ── */}
            <header
                className="nav-root"
                style={{
                    background: scrolled
                        ? "var(--color-navy)"
                        : "var(--color-navy-transparent)",
                }}
            >
                <div
                    className="flex items-center justify-between px-6 lg:px-12"
                    style={{ height: "68px", maxWidth: "1280px", margin: "0 auto" }}
                >
                    {/* Logo */}
                    <Link
                        href="/homepage"
                        aria-label="GFS Service Ltd. — Home"
                        className="flex items-center no-underline"
                    >
                        <img
                            src="/assets/images/logo.svg"
                            alt="GFS Service Ltd."
                            style={{ height: "50px", width: "auto" }}
                        />
                    </Link>

                    {/* Desktop Nav */}
                    <nav className="hidden md:flex items-center gap-10" aria-label="Primary navigation">
                        {navLinks?.map((l) => (
                            <Link
                                key={l?.href}
                                href={l?.href}
                                className={`nav-link${pathname === l?.href ? " active" : ""}`}
                            >
                                {l?.label}
                            </Link>
                        ))}
                    </nav>

                    {/* Mobile Hamburger */}
                    <button
                        className="md:hidden flex flex-col gap-[5px] p-2"
                        onClick={() => setOpen(!open)}
                        aria-label={open ? "Close menu" : "Open menu"}
                        aria-expanded={open}
                    >
                        <span
                            className="block h-[1.5px] bg-white transition-all duration-200"
                            style={{
                                width: "24px",
                                transform: open ? "rotate(45deg) translate(5px,5px)" : "none",
                            }}
                        />
                        <span
                            className="block h-[1.5px] bg-white transition-all duration-200"
                            style={{
                                width: "24px",
                                opacity: open ? 0 : 1,
                            }}
                        />
                        <span
                            className="block h-[1.5px] bg-white transition-all duration-200"
                            style={{
                                width: "24px",
                                transform: open ? "rotate(-45deg) translate(5px,-5px)" : "none",
                            }}
                        />
                    </button>
                </div>
            </header>
            {/* ── Mobile Menu ── */}
            <div
                className={`mobile-menu${open ? " open" : ""}`}
                role="dialog"
                aria-modal="true"
                aria-label="Mobile navigation"
            >
                <nav className="flex flex-col gap-8">
                    {navLinks?.map((l) => (
                        <Link
                            key={l?.href}
                            href={l?.href}
                            className={`nav-link${pathname === l?.href ? " active" : ""}`}
                            onClick={() => setOpen(false)}
                        >
                            {l?.label}
                        </Link>
                    ))}
                </nav>
                <div className="mt-auto">
                    <Link
                        href="/contact"
                        className="btn-primary w-full justify-center"
                        onClick={() => setOpen(false)}
                    >
                        Request Proposal
                    </Link>
                </div>
            </div>
        </>
    );
}